<template>

    <main class="sermons-page">

        <section class="sermons-page__hero">

            <div class="container">

                <span class="sermons-page__eyebrow">
                    SERMONS
                </span>

                <h1>
                    Watch Our Latest Sermons
                </h1>

                <p>
                    Watch recent messages and continue growing in God's Word.
                </p>

            </div>

        </section>

        <section class="sermons-page__content">

            <div class="container">

                <div class="sermons-page__grid">

                    <article
                        v-for="(sermon, index) in $options.filters.portfolioFetchBy('sermons')"
                        :key="index"
                        class="sermon-card"
                    >

                        <div class="sermon-card__image">

                            <img
                                :src="sermon.imagenes_id | imageIdToURL"
                                :alt="sermon.title"
                            >

                            <div class="sermon-card__play">
                                ▶
                            </div>

                        </div>

                        <div class="sermon-card__content">

                            <h2>
                                {{ sermon.title }}
                            </h2>

                            <vue-marked>
                                {{ sermon.content_alt }}
                            </vue-marked>

                            <router-link
                                :to="{
                                    name: 'SermonDetail',
                                    params: {
                                        id: sermon.id,
                                        title: sermon.title
                                    }
                                }"
                            >
                                WATCH SERMON
                                <span>→</span>
                            </router-link>

                        </div>

                    </article>

                </div>

            </div>

        </section>

    </main>

</template>

<script>
export default {
    name: 'Sermons'
};
</script>

<style lang="scss" scoped>
.sermons-page {
    background: #f8f8f6;

    &__hero {
        padding: 160px 20px 90px;

        background: #262626;

        text-align: center;

        .container {
            width: 100%;
            max-width: 1000px;

            margin: 0 auto;
        }

        h1 {
            margin: 12px 0 20px;

            font-family: 'Cormorant Garamond', serif;

            font-size: clamp(3rem, 8vw, 5rem);
            font-weight: 600;

            color: #fff;

            line-height: .98;
        }

        p {
            max-width: 650px;

            margin: 0 auto;

            color: rgba(255, 255, 255, .7);

            font-size: 1rem;

            line-height: 1.8;
        }
    }

    &__eyebrow {
        color: var(--primary);

        font-size: .75rem;
        font-weight: 700;

        letter-spacing: 2px;

        text-transform: uppercase;
    }

    &__content {
        padding: 70px 20px 100px;

        .container {
            width: 100%;
            max-width: 1200px;

            margin: 0 auto;
        }
    }

    &__grid {
        display: grid;

        grid-template-columns: 1fr;

        gap: 35px;
    }
}

.sermon-card {
    background: #fff;

    overflow: hidden;

    border: 1px solid #e8e8e8;

    box-shadow: 0 12px 30px rgba(0, 0, 0, .04);

    transition:
        transform .3s ease,
        box-shadow .3s ease;

    &__image {
        position: relative;

        overflow: hidden;

        img {
            display: block;

            width: 100%;

            aspect-ratio: 16 / 9;

            object-fit: cover;

            transition: transform .4s ease;
        }
    }

    &__play {
        position: absolute;

        top: 50%;
        left: 50%;

        transform: translate(-50%, -50%);

        width: 60px;
        height: 60px;

        display: flex;
        align-items: center;
        justify-content: center;

        padding-left: 4px;

        border-radius: 50%;

        background: var(--primary);
        color: #fff;

        font-size: 1.25rem;

        box-shadow: 0 8px 25px rgba(0, 0, 0, .2);
    }

    &__content {
        padding: 25px;

        h2 {
            margin: 0 0 14px;

            font-family: 'Cormorant Garamond', serif;

            font-size: 2rem;
            font-weight: 600;

            line-height: 1.1;

            color: var(--text);
        }

        ::v-deep p {
            margin: 0 0 20px;

            color: #5f5f5f;

            font-size: .95rem;

            line-height: 1.7;
        }

        a {
            display: inline-flex;

            align-items: center;

            gap: 8px;

            color: var(--primary);

            font-size: .78rem;
            font-weight: 700;

            letter-spacing: 1px;

            text-decoration: none;

            span {
                transition: transform .3s ease;
            }

            &:hover {

                span {
                    transform: translateX(4px);
                }
            }
        }
    }

    &:hover {
        transform: translateY(-5px);

        box-shadow: 0 18px 40px rgba(0, 0, 0, .08);

        .sermon-card__image img {
            transform: scale(1.03);
        }
    }
}

@media (min-width: 768px) {
    .sermons-page {

        &__content {
            padding: 90px 30px 120px;
        }

        &__grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }
}

@media (min-width: 1100px) {
    .sermons-page {

        &__grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }
}
</style>